export default __webpack_public_path__ + "static/media/landing.b8dbfbca.jpg";